import React from 'react';
import Icon from '../Icon';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contextProviders';

function NoSegmentationRow({ onSegmentationAdd, addSegmentationClassName }) {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation('SegmentationTable');
  return (
    <div
      className={`group ${addSegmentationClassName}`}
      onClick={onSegmentationAdd}
    >
      <div className={`${isDarkMode ? 'text-black bg-customLightColor-level2' : 'text-primary-active'} group-hover:${isDarkMode ? 'bg-customLightColor-level3' : 'bg-secondary-dark'} flex items-center rounded-[4px] group-hover:cursor-pointer`}>
        <div className="grid h-[28px] w-[28px] place-items-center">
          <Icon name="icon-add" />
        </div>
        <span className="text-[13px]">{t('Add segmentation')}</span>
      </div>
    </div>
  );
}

export default NoSegmentationRow;
